import styled from "styled-components";

export const BoardDetail = styled.div`
  width: calc(100vw);
  display: flex;
  padding: 16px;
  flex-direction: column;
`;

export const BoardTitleBox = styled.div`
  gap: 6px;
  width: 100%;
  color: ${(props) => props.theme.colors.text4};
  display: flex;
  padding: 0 16px 20px;
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 150%;
  flex-direction: column;

  span {
    color: ${(props) => props.theme.colors.primary100};
    font-size: 1.3rem;
    line-height: 130%;
  }
`;

export const BoardContentBox = styled.div`
  padding: 20px 16px;
  font-size: 1.4rem;
  word-break: keep-all;
  border-top: 1px solid ${(props) => props.theme.colors.black5};
  line-height: 160%;
  white-space: pre-line;
`;

export const BoardInfoBox = styled.div`
  color: ${(props) => props.theme.colors.text2};
  padding: 0 16px;
  font-size: 1.2rem;
  text-align: right;
`;
